import { ExportFileResponse } from 'src/modules/me/models/exportFileResponse';
import { ExportFileSearchFilter } from 'src/modules/me/models/exportFilterSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'ExportFile';

export const getAllExportFiles = (searchFilter: ExportFileSearchFilter) => {
  return AxiosInstance.get<PagedResult<ExportFileResponse>>(controller, { params: searchFilter });
};

export const downloadExportFileById = (exportFileId: number, fileType: string) => {
  const endpoint = `${controller}/${exportFileId}/Data`;
  return AxiosInstance.get(endpoint, {
    responseType: 'blob', // VERY IMPORTANT
    headers: { Accept: fileType },
  });
};
